// extracted by mini-css-extract-plugin
export default {"stickyHeader":"OxEHFa"};